export interface WorkflowTargetInfoModel {
  type: string;
  targetId: string;
  projectId: string;
  stepName: string;
  correctRole: boolean;
  blocked: boolean;
  stepRoles: string[];
}

export function workflowTargetInfoModelFactory(json?: any): WorkflowTargetInfoModel {
  json = json || {};

  return {
    type: json["type"],
    targetId: json["targetId"],
    projectId: json["projectId"],
    stepName: json["stepName"],
    correctRole: json["correctRole"],
    blocked: json["blocked"],
    stepRoles: json["stepRoles"] || [],
  };
}
